module.exports = __webpack_public_path__ + "static/media/bunny-icon.4aede032.jpg";